module.exports = __webpack_public_path__ + "img/eth-balance.a86c7bb4.svg";